import Swiper from '../vendor/swiper'

// Product-page Slider
for (const container of  document.querySelectorAll('.container') ) {
  let feedbackSlider = new Swiper(container.querySelector('.feedback-section__slider'), {
    slidesPerView: 2,
    // slidesPerGroup: 2,
    spaceBetween: 20,
    loop: true,
    observer: true,
    observeParents: true,
    adaptiveHeight: true,
    navigation: {
      nextEl: container.querySelector(".slider__btn-next"),
      prevEl: container.querySelector(".slider__btn-prev"),
      clickable: true
    },
    pagination: {
      el: ".feedback-section__pagination",
      clickable: true
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      576: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      }
    },
  });

  let teamSlider = new Swiper(container.querySelector('.team-section__slider'), {
    slidesPerView: 4,
    // slidesPerGroup: 2,
    spaceBetween: 20,
    loop: true,
    observer: true,
    observeParents: true,
    adaptiveHeight: true,
    navigation: {
      nextEl: container.querySelector(".slider__btn-next"),
      prevEl: container.querySelector(".slider__btn-prev"),
      clickable: true
    },
    pagination: {
      el: ".team-section__pagination",
      clickable: true
    },
    breakpoints: {
      320: {
        slidesPerView: 1.70,
        spaceBetween: 20,
      },
      576: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      992: {
        slidesPerView: 4,
        spaceBetween: 20,
      }
    }
  });

  let casesSlider = new Swiper(container.querySelector('.cases-slider__slider'), {
    slidesPerView: 1,
    loop: true,
    observer: true,
    observeParents: true,
    adaptiveHeight: true,
    navigation: {
      nextEl: document.querySelector(".cases-slider__btn--next"),
      prevEl: document.querySelector(".cases-slider__btn--prev"),
      clickable: true
    }
  });
}

let teamPopupSlider = new Swiper(document.querySelector('.modal__team-slider'), {
  slidesPerView: 1,
  spaceBetween: 20,
  loop: true,
  observer: true,
  observeParents: true,
  adaptiveHeight: true,
  navigation: {
    nextEl: document.querySelector(".modal__team-slider--next"),
    prevEl: document.querySelector(".modal__team-slider--prev"),
    clickable: true,
  },
});









